export async function compressImage(file: File, target?: number): Promise<File> {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.onload = () => {
      const img = new Image()
      img.src = reader.result as string

      img.onload = () => {
        const targetSize = target || 2000
        const aspectRatio = img.width / img.height

        let scaledWidth, scaledHeight
        if (aspectRatio > 1) {
          scaledWidth = targetSize * aspectRatio
          scaledHeight = targetSize
        } else {
          scaledHeight = targetSize / aspectRatio
          scaledWidth = targetSize
        }

        const canvas = document.createElement('canvas')
        canvas.width = targetSize
        canvas.height = targetSize
        const ctx = canvas.getContext('2d')

        const offsetX = (scaledWidth - targetSize) / 2
        const offsetY = (scaledHeight - targetSize) / 2

        ctx?.drawImage(
          img,
          -offsetX,
          -offsetY,
          scaledWidth,
          scaledHeight,
        )

        canvas.toBlob(
          (blob) => {
            const compressedFile = new File([blob!], file.name, {
              type: 'image/jpeg',
            })
            resolve(compressedFile)
          },
          'image/jpeg',
          0.8,
        )
      }
    }

    reader.readAsDataURL(file)
  })
}
